import React from 'react';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section id="contact" className="py-20 bg-gray-800" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="bg-gradient-to-r from-red-900 to-red-800 rounded-2xl overflow-hidden shadow-xl" data-id="element-15">
          <div className="px-6 py-12 sm:px-12 sm:py-16 lg:flex lg:items-center lg:justify-between" data-id="element-16">
            <div className="lg:w-0 lg:flex-1" data-id="element-17">
              <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-18">
                Ready to secure your digital assets?
              </h2>
              <p className="mt-4 max-w-3xl text-lg text-red-100" data-id="element-19">
                Get in touch with our team to schedule a consultation and
                discover how our penetration testing services can protect your
                business from cyber threats.
              </p>
              <div className="mt-8 flex flex-wrap gap-4" data-id="element-20">
                <div className="flex items-center text-red-200" data-id="element-21">
                  <div className="flex-shrink-0" data-id="element-22">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-23">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-24" />
                    </svg>
                  </div>
                  <p className="ml-3 text-sm" data-id="element-25">Detailed vulnerability reports</p>
                </div>
                <div className="flex items-center text-red-200" data-id="element-26">
                  <div className="flex-shrink-0" data-id="element-27">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-28">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-29" />
                    </svg>
                  </div>
                  <p className="ml-3 text-sm" data-id="element-30">Actionable remediation steps</p>
                </div>
                <div className="flex items-center text-red-200" data-id="element-31">
                  <div className="flex-shrink-0" data-id="element-32">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-33">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-34" />
                    </svg>
                  </div>
                  <p className="ml-3 text-sm" data-id="element-35">Post-remediation testing</p>
                </div>
              </div>
            </div>
            <div className="mt-8 lg:mt-0 lg:ml-8" data-id="element-36">
              <form className="sm:flex sm:max-w-md" data-id="element-37">
                <div className="space-y-4 sm:space-y-0 sm:flex-1" data-id="element-38">
                  <input type="email" placeholder="Enter your email" className="block w-full px-5 py-3 text-base text-gray-900 placeholder-gray-500 border border-transparent rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-red-500" data-id="element-39" />
                  <input type="text" placeholder="Company name" className="block w-full px-5 py-3 text-base text-gray-900 placeholder-gray-500 border border-transparent rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-red-500" data-id="element-40" />
                </div>
                <div className="mt-4 sm:mt-0 sm:ml-3" data-id="element-41">
                  <button type="submit" className="block w-full px-5 py-3 text-base font-medium text-white bg-red-600 border border-transparent rounded-md shadow hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 sm:px-10" data-id="element-42">
                    <span className="flex items-center justify-center" data-id="element-43">
                      Request Demo
                      <ArrowRight className="ml-2 h-5 w-5" data-id="element-44" />
                    </span>
                  </button>
                </div>
              </form>
              <p className="mt-3 text-sm text-red-200" data-id="element-45">
                We'll get back to you within 24 hours.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}